/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/zh_TW';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "存取美觀 HTML 編輯器"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "可訪問性檢查器"
  },
  "action_to_take_b626a99a": {
    "message": "執行的動作："
  },
  "add_8523c19b": {
    "message": "添加"
  },
  "add_a_caption_2a915239": {
    "message": "添加字幕"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "為圖像添加替代文字"
  },
  "add_another_f4e50d57": {
    "message": "添加其他"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "添加副本/字幕"
  },
  "add_image_60b2de07": {
    "message": "添加影像"
  },
  "add_one_9e34a6f8": {
    "message": "添加一個！"
  },
  "additional_considerations_f3801683": {
    "message": "其他考慮因素"
  },
  "address_applied_64269b0b": {
    "message": "已套用位址"
  },
  "address_removed_fcb496e0": {
    "message": "已移除位址"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "URL 相同的相鄰連結應為單一連結。"
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "對齊"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "對齊及清單"
  },
  "all_4321c3a1": {
    "message": "全部"
  },
  "all_apps_a50dea49": {
    "message": "所有應用程式"
  },
  "allow_media_download_16dcf2bd": {
    "message": "允許媒體下載"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "允許成績單下載"
  },
  "alpha_15d59033": {
    "message": "α"
  },
  "alphabetical_55b5b4e0": {
    "message": "字母"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "替代屬性文字不應包含多於 120 個字元。"
  },
  "alt_text_611fb322": {
    "message": "替代文字"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg（副產品）"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "讀取作業時發生錯誤"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "發出連線請求時發生錯誤"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "上載媒體時發生錯誤。"
  },
  "and_7fcc2911": {
    "message": "以及"
  },
  "angle_c5b4ec50": {
    "message": "角度"
  },
  "announcement_fb4cb645": {
    "message": "通告"
  },
  "announcement_list_da155734": {
    "message": "通告清單"
  },
  "announcements_a4b8ed4a": {
    "message": "通告"
  },
  "apply_781a2546": {
    "message": "應用"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "在課程中套用變更到此圖示製作者圖示的所有執行個體"
  },
  "approaches_the_limit_893aeec9": {
    "message": "接近限制"
  },
  "approximately_e7965800": {
    "message": "大約"
  },
  "apps_54d24a47": {
    "message": "應用程式"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "是否確定要取消？您所做的變更或未能儲存。"
  },
  "arrows_464a3e54": {
    "message": "箭號"
  },
  "art_icon_8e1daad": {
    "message": "藝術圖示"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "外觀比例將被保留"
  },
  "assignment_976578a8": {
    "message": "作業"
  },
  "assignments_1e02582c": {
    "message": "作業列表"
  },
  "asterisk_82255584": {
    "message": "*"
  },
  "attributes_963ba262": {
    "message": "屬性"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "不支援音訊和視訊錄製；請使用不同的瀏覽器。"
  },
  "audio_options_feb58e2c": {
    "message": "音訊選項"
  },
  "audio_options_tray_33a90711": {
    "message": "音訊選項收集箱"
  },
  "audio_player_for_title_20cc70d": {
    "message": "{ title } 的音訊播放器"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "自動儲存內容已存在。是否要改為載入自動儲存的內容？"
  },
  "available_folders_694d0436": {
    "message": "可用資料夾"
  },
  "background_1bc88842": {
    "message": "背景"
  },
  "backslash_b2d5442d": {
    "message": "反斜线"
  },
  "bar_ec63ed6": {
    "message": "橫線"
  },
  "basic_554cdc0a": {
    "message": "基本"
  },
  "because_501841b": {
    "message": "因為"
  },
  "below_81d4dceb": {
    "message": "以下"
  },
  "beta_cb5f307e": {
    "message": "β"
  },
  "big_circle_16b2e604": {
    "message": "大圓圈"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "二項式係數"
  },
  "black_4cb01371": {
    "message": "黑色"
  },
  "blue_daf8fea9": {
    "message": "藍色"
  },
  "bold_applied_42d547b7": {
    "message": "已套用粗體"
  },
  "bold_removed_da474a5c": {
    "message": "已移除粗體"
  },
  "border_5b08b06d": {
    "message": "邊框"
  },
  "bottom_15a2a9be": {
    "message": "底部"
  },
  "bottom_third_5f5fec1d": {
    "message": "底部第三個"
  },
  "bowtie_5f9629e4": {
    "message": "領結"
  },
  "brick_f2656265": {
    "message": "磚頭"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "取消"
  },
  "cap_product_3a5265a6": {
    "message": "便帽產品"
  },
  "caption_manager_aae0906f": {
    "message": "字幕管理員"
  },
  "center_align_e68d9997": {
    "message": "置中對齊"
  },
  "centered_dot_64d5e378": {
    "message": "中心點"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "中心水平點"
  },
  "change_alt_text_92654906": {
    "message": "變更替代文字"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "變更標題標籤為段落"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "僅變更此標題的級別"
  },
  "change_text_color_1aecb912": {
    "message": "變更文字顏色"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "儲存本頁面後，套用變更。"
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "您所做的變更或未能儲存。"
  },
  "characters_9d897d1c": {
    "message": "性質"
  },
  "characters_no_spaces_485e5367": {
    "message": "字元（無空格）"
  },
  "check_accessibility_3c78211c": {
    "message": "檢查可訪問性"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "檢查可訪問性問題"
  },
  "chi_54a32644": {
    "message": "χ"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "選擇字幕檔案"
  },
  "choose_usage_rights_33683854": {
    "message": "選擇使用權限…"
  },
  "circle_484abe63": {
    "message": "圓形"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "圓形無序清單"
  },
  "clear_2084585f": {
    "message": "清除"
  },
  "clear_image_3213fe62": {
    "message": "清除影像"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "點擊或按住 Shift 點擊調出 html 編輯器。"
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "按一下以嵌入 { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "按一下以隱藏預覽"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "按一下以插入一個連結至編輯。"
  },
  "click_to_show_preview_faa27051": {
    "message": "按一下以顯示預覽"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "關閉選單或對話方塊。另外請返回編輯器區域"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "關閉可訪問性檢查器"
  },
  "close_d634289d": {
    "message": "關閉"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "關閉鍵盤快速鍵模態"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "關閉的字幕檔案必須小於 { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "隱藏圖片說明/字幕"
  },
  "clubs_suit_c1ffedff": {
    "message": "梅花（花色）"
  },
  "collab_575ac7bc": {
    "message": "協作"
  },
  "collaborations_5c56c15f": {
    "message": "協作"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "收起以隱藏 { types }"
  },
  "color_a363e1b0": {
    "message": "顏色"
  },
  "color_contrast_4c418add": {
    "message": "顏色對比度"
  },
  "color_contrast_ratio_687782f0": {
    "message": "顏色對比度比率"
  },
  "color_picker_6b359edf": {
    "message": "顏色選擇器"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "顏色選擇器（已選擇 { colorName } 色）"
  },
  "color_popup_af39810f": {
    "message": "顏色彈出視窗"
  },
  "column_e1ae5c64": {
    "message": "欄"
  },
  "column_group_1c062368": {
    "message": "欄組"
  },
  "complex_numbers_a543d004": {
    "message": "複數"
  },
  "computer_1d7dfa6f": {
    "message": "電腦"
  },
  "congruent_5a244acd": {
    "message": "全等"
  },
  "contains_311f37b7": {
    "message": "含有"
  },
  "content_1440204b": {
    "message": "內容"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "編輯器中的內容將會變更。按下「取消」保留原始內容。"
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "內容仍在上傳中，如果您繼續將無法正確嵌入內容。"
  },
  "content_subtype_5ce35e88": {
    "message": "內容子類型"
  },
  "content_type_2cf90d95": {
    "message": "內容類型"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "繼續觀看 YouTube 內容"
  },
  "coproduct_e7838082": {
    "message": "副產品"
  },
  "copyright_holder_66ee111": {
    "message": "版權持有人："
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "無法插入內容：Canvas 中目前不支援「{ itemType }」項目。"
  },
  "count_40eced3b": {
    "message": "計數"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 個字}\n    one {1 個字}\n  other {# 個字}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# 個項目已載入}\n  other {# 個項目已載入}\n}"
  },
  "course_documents_104d76e0": {
    "message": "課程文件"
  },
  "course_files_62deb8f8": {
    "message": "課程檔案"
  },
  "course_files_a31f97fc": {
    "message": "課程檔案"
  },
  "course_images_f8511d04": {
    "message": "課程影像"
  },
  "course_link_b369426": {
    "message": "課程連結"
  },
  "course_links_b56959b9": {
    "message": "課程連結"
  },
  "course_media_ec759ad": {
    "message": "課程媒體"
  },
  "course_navigation_dd035109": {
    "message": "課程導航"
  },
  "create_icon_110d6463": {
    "message": "建立圖示"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "建立圖示 製作者圖示"
  },
  "creative_commons_license_725584ae": {
    "message": "創意共享授權："
  },
  "crop_image_41bf940c": {
    "message": "裁剪影像"
  },
  "crop_image_807ebb08": {
    "message": "裁剪影像"
  },
  "cup_product_14174434": {
    "message": "杯子產品"
  },
  "current_image_f16c249c": {
    "message": "目前的圖像"
  },
  "current_link_945a47ee": {
    "message": "目前的連結"
  },
  "current_volume_level_c55ab825": {
    "message": "目前音量"
  },
  "custom_6979cd81": {
    "message": "自訂"
  },
  "cyan_c1d5f68a": {
    "message": "青色"
  },
  "dagger_57e0f4e5": {
    "message": "劍號"
  },
  "date_added_ed5ad465": {
    "message": "添加的日期"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "裝飾圖示"
  },
  "decorative_image_fde98579": {
    "message": "裝飾圖像"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "裝飾 { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "減少縮排"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "減少多種格式的內容區域"
  },
  "deep_purple_bb3e2907": {
    "message": "深紫色"
  },
  "default_9db103d": {
    "message": "預設"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "預設符號無序清單"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "預設數字有序清單"
  },
  "definite_integral_fe7ffed1": {
    "message": "有限積分"
  },
  "degree_symbol_4a823d5f": {
    "message": "度數符號"
  },
  "delimiters_4db4840d": {
    "message": "分隔符號"
  },
  "delta_53765780": {
    "message": "δ"
  },
  "describe_the_icon_f6a18823": {
    "message": "（描述圖示）"
  },
  "describe_the_type_ff448da5": {
    "message": "（描述 { TYPE }）"
  },
  "description_436c48d7": {
    "message": "描述"
  },
  "details_98a31b68": {
    "message": "詳細資料"
  },
  "diagonal_dots_7d71b57e": {
    "message": "對角點"
  },
  "diamond_b8dfe7ae": {
    "message": "鑽石形"
  },
  "diamonds_suit_526abaaf": {
    "message": "方塊（花色）"
  },
  "digamma_258ade94": {
    "message": "雙伽瑪"
  },
  "dimension_type_f5fa9170": {
    "message": "尺寸類型"
  },
  "directionality_26ae9e08": {
    "message": "方向"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "直接編輯 LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "停用預覽"
  },
  "discussion_6719c51d": {
    "message": "討論"
  },
  "discussions_a5f96392": {
    "message": "討論區"
  },
  "discussions_index_6c36ced": {
    "message": "討論索引"
  },
  "disjoint_union_e74351a8": {
    "message": "互斥聯集"
  },
  "display_options_315aba85": {
    "message": "顯示選項"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "顯示文字連結（在新標籤中開啟）"
  },
  "div_applied_49ad83fc": {
    "message": "已套用 Div"
  },
  "div_removed_d13f8e17": {
    "message": "已移除 Div"
  },
  "division_sign_72190870": {
    "message": "除號"
  },
  "document_678cd7bf": {
    "message": "文件"
  },
  "documents_81393201": {
    "message": "文件"
  },
  "done_54e3d4b6": {
    "message": "已完成"
  },
  "double_dagger_faf78681": {
    "message": "雙劍號"
  },
  "down_5831a426": {
    "message": "向下"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "向下和向左對角箭頭"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "向下和向右對角箭頭"
  },
  "download_filename_2baae924": {
    "message": "下載 { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "向下箭頭"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "向下指向三角形"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "拖曳檔案到此處。"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "拖放或按一下以瀏覽您的電腦"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "拖曳控點。使用上下箭頭重新調整大小"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "截止日期：多個日期"
  },
  "due_when_7eed10c6": {
    "message": "截止日期：{ when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "編輯此圖示實例的 alt 文字"
  },
  "edit_c5fbea07": {
    "message": "編輯"
  },
  "edit_course_link_5a5c3c59": {
    "message": "編輯課程連結"
  },
  "edit_equation_f5279959": {
    "message": "編輯方程式"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "編輯現有的圖示製作者圖示"
  },
  "edit_icon_2c6b0e91": {
    "message": "編輯圖示"
  },
  "edit_link_7f53bebb": {
    "message": "編輯連結"
  },
  "editor_status_bar_653f44ee": {
    "message": "編輯器狀態列"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "以 { start } 開始的元素"
  },
  "embed_828fac4a": {
    "message": "嵌入"
  },
  "embed_code_314f1bd5": {
    "message": "嵌入代碼"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "從外部工具嵌入的內容"
  },
  "embed_image_1080badc": {
    "message": "嵌入影像"
  },
  "embed_video_a97a64af": {
    "message": "嵌入影片"
  },
  "embedded_content_aaeb4d3d": {
    "message": "嵌入內容"
  },
  "empty_set_91a92df4": {
    "message": "空集合"
  },
  "encircled_dot_8f5e51c": {
    "message": "圓圈點"
  },
  "encircled_minus_72745096": {
    "message": "⊖ "
  },
  "encircled_plus_36d8d104": {
    "message": "⊕"
  },
  "encircled_times_5700096d": {
    "message": "⊗"
  },
  "engineering_icon_f8f3cf43": {
    "message": "工程圖示"
  },
  "english_icon_25bfe845": {
    "message": "英文圖示"
  },
  "enter_a_media_title_81b490ec": {
    "message": "輸入媒體標題"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "請輸入最少 3 個字元以開始搜尋"
  },
  "enter_replacement_text_17631bbc": {
    "message": "輸入取代文字"
  },
  "enter_search_text_26cb4459": {
    "message": "輸入搜尋文字"
  },
  "epsilon_54bb8afa": {
    "message": "ɛ"
  },
  "epsilon_variant_d31f1e77": {
    "message": "ɛ（變量）"
  },
  "equals_sign_c51bdc58": {
    "message": "等號"
  },
  "equation_1c5ac93c": {
    "message": "方程式"
  },
  "equation_editor_39fbc3f1": {
    "message": "方程式編輯器"
  },
  "equilibrium_6ff3040b": {
    "message": "相等"
  },
  "equivalence_class_7b0f11c0": {
    "message": "等價類"
  },
  "equivalent_identity_654b3ce5": {
    "message": "等價（單位）"
  },
  "eta_b8828f99": {
    "message": "η"
  },
  "exists_2e62bdaa": {
    "message": "存在"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "退出全螢幕"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "預設為展開預覽"
  },
  "expand_to_see_types_f5d29352": {
    "message": "展開以查看 { types }"
  },
  "external_link_d3f9e62a": {
    "message": "外部連結"
  },
  "external_tool_frame_70b32473": {
    "message": "外部工具框"
  },
  "external_tools_6e77821": {
    "message": "外部工具"
  },
  "extra_large_b6cdf1ff": {
    "message": "超大"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "超大尺寸（{ width } x { height }像素）"
  },
  "extra_small_9ae33252": {
    "message": "超小"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "課外活動圖示"
  },
  "f_function_fe422d65": {
    "message": "F（函數）"
  },
  "fail_544e5dde": {
    "message": "失敗"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "無法取得檔案內容"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "無法從外部工具擷取內容"
  },
  "file_name_8fd421ff": {
    "message": "檔案名稱"
  },
  "file_preview_21667a6e": {
    "message": "檔案預覽"
  },
  "file_preview_for_filename_ab314195": {
    "message": "{ fileName } 的檔案預覽"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "已超過檔案儲存配額"
  },
  "file_url_c12b64be": {
    "message": "檔案 URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } 檔案圖示"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } 影像預覽"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } 文字預覽"
  },
  "files_c300e900": {
    "message": "檔案"
  },
  "files_index_af7c662b": {
    "message": "檔案索引"
  },
  "find_8d605019": {
    "message": "尋找"
  },
  "find_and_replace_6e345933": {
    "message": "尋找和取代"
  },
  "finish_bc343002": {
    "message": "完成"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "固定標題階層"
  },
  "flat_music_76d5a5c3": {
    "message": "♭（音樂）"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "聚焦元素選項工具欄"
  },
  "folder_tree_fbab0726": {
    "message": "樹狀資件夾"
  },
  "for_all_b919f972": {
    "message": "適用全部"
  },
  "format_4247a9c5": {
    "message": "格式"
  },
  "format_as_a_list_142210c3": {
    "message": "使用清單格式"
  },
  "formatting_5b143aa8": {
    "message": "格式"
  },
  "forward_slash_3f90f35e": {
    "message": "/"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "找到自動儲存的內容"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "找到 { count, plural,\n     =0 {# 個結果 }\n    one {# 個結果 }\n  other {# 個結果 }\n}"
  },
  "fraction_41bac7af": {
    "message": "分數"
  },
  "fullscreen_873bf53f": {
    "message": "全螢幕"
  },
  "gamma_1767928": {
    "message": "γ"
  },
  "generating_preview_45b53be0": {
    "message": "產生預覽中..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "GIF/PNG 格式影像大於目前不支援的 { size } KB。"
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "前往編輯器的選單欄"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "前往編輯器的工具欄"
  },
  "grades_a61eba0a": {
    "message": "成績"
  },
  "graphics_text_bc9568bc": {
    "message": "圖形文字"
  },
  "greater_than_e98af662": {
    "message": ">"
  },
  "greater_than_or_equal_b911949a": {
    "message": "> 或 ="
  },
  "greek_65c5b3f7": {
    "message": "希臘語"
  },
  "green_15af4778": {
    "message": "綠色"
  },
  "grey_a55dceff": {
    "message": "灰色"
  },
  "group_documents_8bfd6ae6": {
    "message": "群組文件"
  },
  "group_files_4324f3df": {
    "message": "群組檔案"
  },
  "group_files_82e5dcdb": {
    "message": "群組檔案"
  },
  "group_images_98e0ac17": {
    "message": "群組圖像"
  },
  "group_isomorphism_45b1458c": {
    "message": "揚抑符號"
  },
  "group_link_63e626b3": {
    "message": "群組連結"
  },
  "group_links_9493129e": {
    "message": "群組連結"
  },
  "group_media_2f3d128a": {
    "message": "群組媒體"
  },
  "group_navigation_99f191a": {
    "message": "群組導航"
  },
  "h_bar_bb94deae": {
    "message": "H 列"
  },
  "hat_ea321e35": {
    "message": "揚抑符號"
  },
  "header_column_f27433cb": {
    "message": "標題欄"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "標題行與欄"
  },
  "header_row_f33eb169": {
    "message": "標題行"
  },
  "heading_2_5b84eed2": {
    "message": "標題 2"
  },
  "heading_3_2c83de44": {
    "message": "標題 3"
  },
  "heading_4_b2e74be7": {
    "message": "標題 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "已套用標題 { h }"
  },
  "heading_h_removed_745f24a6": {
    "message": "已移除標題 { h }"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "不應跳過標題層。"
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "以 { start } 開始的標題"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "標題不應包含多於 120 個字元。"
  },
  "health_icon_8d292eb5": {
    "message": "健康圖示"
  },
  "hearts_suit_e50e04ca": {
    "message": "紅心（花色）"
  },
  "height_69b03e15": {
    "message": "高度"
  },
  "hexagon_d8468e0d": {
    "message": "六邊形"
  },
  "hide_description_bfb5502e": {
    "message": "隱藏描述"
  },
  "hide_title_description_caf092ef": {
    "message": "隱藏 { title } 描述"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "反白顯示元素以啟用元素選項工具欄"
  },
  "home_351838cd": {
    "message": "首頁"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "如何申請和編輯標題？"
  },
  "html_code_editor_fd967a44": {
    "message": "Html 代碼編輯器"
  },
  "html_editor_fb2ab713": {
    "message": "HTML 編輯器"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "我已經獲得了該文檔的使用權限。"
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "我持有該版權"
  },
  "icon_215a1dc6": {
    "message": "圖示"
  },
  "icon_8168b2f8": {
    "message": "圖示"
  },
  "icon_color_b86dd6d6": {
    "message": "圖示色彩"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "圖示製作者圖示"
  },
  "icon_options_7e32746e": {
    "message": "圖示選項"
  },
  "icon_options_tray_2b407977": {
    "message": "圖示選項收集箱"
  },
  "icon_preview_1782a1d9": {
    "message": "圖示預覽"
  },
  "icon_shape_30b61e7": {
    "message": "圖示形狀"
  },
  "icon_size_9353edea": {
    "message": "圖示大小"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "在左側空白連結中，文字將顯示為課程連結名稱"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "如果需要使用權限，在「檔案」頁面中啟用前將無法發佈檔案。"
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "如果您現在不選擇使用權，那麼該文檔在其上傳之後將會撤銷發佈。"
  },
  "image_8ad06": {
    "message": "影像"
  },
  "image_c1c98202": {
    "message": "影像"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "圖像檔案名稱不應用作說明圖像內容的替代屬性。"
  },
  "image_options_5412d02c": {
    "message": "影像選項"
  },
  "image_options_tray_90a46006": {
    "message": "影像選項收集箱"
  },
  "image_to_crop_3a34487d": {
    "message": "要裁剪的圖像"
  },
  "image_with_filename_file_aacd7180": {
    "message": "檔案名稱為 { file } 的圖像"
  },
  "images_7ce26570": {
    "message": "影像"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "圖像應包括說明圖像內容的替代屬性。"
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "虛數部份（複數的）"
  },
  "in_element_of_19ca2f33": {
    "message": "在（某個元素）"
  },
  "increase_indent_6af90f7c": {
    "message": "增加縮進"
  },
  "increase_rich_content_area_340b775": {
    "message": "增加多種格式的內容區域"
  },
  "indefinite_integral_6623307e": {
    "message": "無限積分"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ max } 的 { index }"
  },
  "indigo_2035fc55": {
    "message": "靛藍色"
  },
  "inference_fed5c960": {
    "message": "推論"
  },
  "infinity_7a10f206": {
    "message": "無限"
  },
  "input_field_for_alpha_678265fd": {
    "message": "α 系數的輸入欄位"
  },
  "input_field_for_blue_561e020a": {
    "message": "藍色的輸入欄位"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "綠色的輸入欄位"
  },
  "input_field_for_red_86a84615": {
    "message": "紅色的輸入欄位"
  },
  "insert_593145ef": {
    "message": "插入"
  },
  "insert_link_6dc23cae": {
    "message": "插入連結"
  },
  "insert_math_equation_57c6e767": {
    "message": "插入數學方程式"
  },
  "integers_336344e1": {
    "message": "整數"
  },
  "intersection_cd4590e4": {
    "message": "交集"
  },
  "invalid_description_991e23bb": {
    "message": "無效的描述"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "無效的輸入項目。"
  },
  "invalid_file_c11ba11": {
    "message": "無效的檔案"
  },
  "invalid_file_type_881cc9b2": {
    "message": "無效的檔案類型"
  },
  "invalid_url_cbde79f": {
    "message": "無效的 URL"
  },
  "iota_11c932a9": {
    "message": "ι"
  },
  "issue_num_total_f94536cf": {
    "message": "問題 { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "已套用斜體"
  },
  "italic_removed_17cbab6f": {
    "message": "已移除斜體 "
  },
  "kappa_2f14c816": {
    "message": "κ"
  },
  "kappa_variant_eb64574b": {
    "message": "κ（變量）"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "鍵盤快速鍵"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "使用 Tab 鍵以鍵盤導航至連結。目的地相同的兩個相連連結可能對鍵盤使用者造成混亂。"
  },
  "lambda_4f602498": {
    "message": "λ"
  },
  "language_arts_icon_a798b0f8": {
    "message": "語言文學圖示"
  },
  "languages_icon_9d20539": {
    "message": "語言圖示"
  },
  "large_9c5e80e7": {
    "message": "大"
  },
  "large_text_e7ba08cd": {
    "message": "大文字"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "大尺寸（{ width } x { height }像素）"
  },
  "learn_ad3b3505": {
    "message": "學習"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "了解更多有關相鄰連結"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "了解更多有關顏色對比"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "了解更多有關組織頁面標題"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "了解更多有關適當的頁面標題結構"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "了解更多有關表格標題"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "了解更多有關使用圖像的 alt 文字"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "了解更多有關使用表格的字幕"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "了解更多有關使用檔案名稱作為 alt 文字"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "了解更多有關使用清單"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "了解更多有關使用有表格的範圍屬性"
  },
  "leave_as_is_4facfe55": {
    "message": "不需變更"
  },
  "left_3ea9d375": {
    "message": "左"
  },
  "left_align_43d95491": {
    "message": "靠左對齊"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "左角括號"
  },
  "left_arrow_4fde1a64": {
    "message": "左箭頭"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "左箭頭與鉤號"
  },
  "left_ceiling_ee9dd88a": {
    "message": "左上限"
  },
  "left_curly_brace_1726fb4": {
    "message": "左大括號"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "左向下魚叉箭頭"
  },
  "left_floor_29ac2274": {
    "message": "左下限"
  },
  "left_to_right_e9b4fd06": {
    "message": "左至右"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "左向上魚叉箭頭"
  },
  "leftward_arrow_1e4765de": {
    "message": "向左箭頭"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "向左指向三角形"
  },
  "less_than_a26c0641": {
    "message": "小於"
  },
  "less_than_or_equal_be5216cb": {
    "message": "小於或等於"
  },
  "library_icon_ae1e54cf": {
    "message": "圖書館圖示"
  },
  "light_blue_5374f600": {
    "message": "淺藍色"
  },
  "link_7262adec": {
    "message": "連結"
  },
  "link_options_a16b758b": {
    "message": "連結選項"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "連結類型：{ linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "文字以 { start } 開始的連結"
  },
  "links_14b70841": {
    "message": "連結"
  },
  "links_to_an_external_site_de74145d": {
    "message": "連結到外部網站。"
  },
  "lists_cd1336fc": {
    "message": "清單"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "列表應使用清單格式。"
  },
  "load_more_35d33c7": {
    "message": "載入更多"
  },
  "loading_25990131": {
    "message": "正在載入……"
  },
  "loading_bde52856": {
    "message": "正在載入"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "載入關閉的說明/字幕失敗。"
  },
  "loading_external_tool_d839042c": {
    "message": "正在載入外部工具"
  },
  "loading_failed_b3524381": {
    "message": "載入失敗……"
  },
  "loading_failed_e6a9d8ef": {
    "message": "載入失敗。"
  },
  "loading_folders_d8b5869e": {
    "message": "正在載入資料夾"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "載入 { fileName } 的佔位符"
  },
  "loading_please_wait_d276220a": {
    "message": "正在載入，請稍候"
  },
  "loading_preview_9f077aa1": {
    "message": "載入預覽"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "鎖定速度為 1 倍速"
  },
  "locked_762f138b": {
    "message": "已鎖定"
  },
  "logical_equivalence_76fca396": {
    "message": "邏輯對等"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "邏輯對等（短）"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "邏輯對等（短和粗）"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "邏輯對等（粗）"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "下水平點"
  },
  "magenta_4a65993c": {
    "message": "品紅"
  },
  "maps_to_e5ef7382": {
    "message": "對應"
  },
  "math_icon_ad4e9d03": {
    "message": "數學圖示"
  },
  "media_af190855": {
    "message": "媒體"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "正在處理媒體檔案中。請稍後重試。"
  },
  "media_options_saved_560c4ec8": {
    "message": "媒體選項已儲存。"
  },
  "media_title_2112243b": {
    "message": "媒體標題"
  },
  "medium_5a8e9ead": {
    "message": "中"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "中尺寸（{ width } x { height }像素）"
  },
  "merge_links_2478df96": {
    "message": "合併連結"
  },
  "mic_a7f3d311": {
    "message": "麥克風"
  },
  "microphone_disabled_15c83130": {
    "message": "停用麥克風"
  },
  "middle_27dc1d5": {
    "message": "中間"
  },
  "minimize_file_preview_da911944": {
    "message": "最小化文檔預覽"
  },
  "minimize_video_20aa554b": {
    "message": "最小化視訊"
  },
  "minus_fd961e2e": {
    "message": "-"
  },
  "minus_plus_3461f637": {
    "message": "+/-"
  },
  "misc_3b692ea7": {
    "message": "雜項"
  },
  "miscellaneous_e9818229": {
    "message": "雜項"
  },
  "module_90d9fd32": {
    "message": "單元"
  },
  "modules_c4325335": {
    "message": "單元"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "移動影像以裁剪 { directionWord }"
  },
  "mu_37223b8b": {
    "message": "x"
  },
  "multi_color_image_63d7372f": {
    "message": "多色圖像"
  },
  "multiplication_sign_15f95c22": {
    "message": "x 號"
  },
  "music_icon_4db5c972": {
    "message": "音樂圖示"
  },
  "my_files_2f621040": {
    "message": "我的檔案"
  },
  "n_th_root_9991a6e4": {
    "message": "N 次方根"
  },
  "nabla_1e216d25": {
    "message": "▽"
  },
  "name_1aed4a1b": {
    "message": "名稱"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "♮（音樂）"
  },
  "natural_numbers_3da07060": {
    "message": "自然數"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "導航整個選單或工具欄"
  },
  "navigation_ee9af92d": {
    "message": "導航工具"
  },
  "nested_greater_than_d852e60d": {
    "message": "巢式大於"
  },
  "nested_less_than_27d17e58": {
    "message": "巢式小於"
  },
  "new_quiz_34aacba6": {
    "message": "新測驗"
  },
  "next_40e12421": {
    "message": "下一個"
  },
  "next_findtext_9d69f0fe": {
    "message": "下一個 { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "並無偵察任何可訪問性問題。"
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "尚未建立通告。"
  },
  "no_announcements_found_20185afc": {
    "message": "找不到通告。"
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "尚未建立作業列表。"
  },
  "no_assignments_found_79e46d7f": {
    "message": "找不到作業列表。"
  },
  "no_changes_to_save_d29f6e91": {
    "message": "沒有要儲存的變更。"
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "尚未建立討論區。"
  },
  "no_discussions_found_9284063b": {
    "message": "找不到討論區。"
  },
  "no_e16d9132": {
    "message": "否"
  },
  "no_file_chosen_9a880793": {
    "message": "未選擇檔案"
  },
  "no_headers_9bc7dc7f": {
    "message": "無標題"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "尚未建立單元。"
  },
  "no_modules_found_2df43a40": {
    "message": "找不到單元。"
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "尚未創建任何頁面。"
  },
  "no_pages_found_6799350": {
    "message": "找不到頁面。"
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "本檔案不支援預覽。"
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "尚未建立測驗。"
  },
  "no_quizzes_found_c80c537a": {
    "message": "找不到測驗。"
  },
  "no_results_940393cf": {
    "message": "無結果。"
  },
  "no_results_found_58717065": {
    "message": "找不到結果"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "找不到 { filterTerm } 的結果"
  },
  "no_video_1ed00b26": {
    "message": "無影片"
  },
  "none_3b5e34d2": {
    "message": "無"
  },
  "none_selected_b93d56d2": {
    "message": "未選擇任何項目"
  },
  "normal_text_7b03da48": {
    "message": "一般文字"
  },
  "not_equal_6e2980e6": {
    "message": "不等於"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "不在（不是某個元素）"
  },
  "not_negation_1418ebb8": {
    "message": "非（否定）"
  },
  "not_subset_dc2b5e84": {
    "message": "非子集合"
  },
  "not_subset_strict_23d282bf": {
    "message": "非子集合（嚴格）"
  },
  "not_superset_5556b913": {
    "message": "非母集合"
  },
  "not_superset_strict_24e06f36": {
    "message": "非母集合（嚴格）"
  },
  "nu_1c0f6848": {
    "message": "ν"
  },
  "octagon_e48be9f": {
    "message": "八邊形"
  },
  "olive_6a3e4d6b": {
    "message": "橄欖色"
  },
  "omega_8f2c3463": {
    "message": "ω"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "必須添加以下其中一個樣式以儲存圖示：圖示色彩、輪廓大小、圖示文字或影像"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "無法貼上一個或多個檔案。請嘗試上傳或拖放檔案。"
  },
  "open_circle_e9bd069": {
    "message": "開圓"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "開啟此鍵盤快速鍵對話方塊"
  },
  "open_title_application_fd624fc5": {
    "message": "開啟 { title } 應用程式"
  },
  "operators_a2ef9a93": {
    "message": "操作員"
  },
  "options_3ab0ea65": {
    "message": "選項"
  },
  "or_9b70ccaa": {
    "message": "或者"
  },
  "orange_81386a62": {
    "message": "橙色"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "有序和無序的清單"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "其他編輯器快速鍵位於"
  },
  "outline_color_3ef2cea7": {
    "message": "輪廓顏色"
  },
  "outline_size_a6059a21": {
    "message": "輪廓大小"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } 不是有效的通訊協定。"
  },
  "page_50c4823d": {
    "message": "頁面"
  },
  "pages_e5414c2c": {
    "message": "頁面"
  },
  "paragraph_5e5ad8eb": {
    "message": "段落"
  },
  "paragraph_applied_959b3fe5": {
    "message": "已套用段落"
  },
  "paragraph_removed_d09320e": {
    "message": "已移除段落"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "以 { start } 開始的段落"
  },
  "parallel_d55d6e38": {
    "message": "平行"
  },
  "partial_derivative_4a9159df": {
    "message": "部份（導數）"
  },
  "pass_1c19a2b3": {
    "message": "合格"
  },
  "paste_5963d1c1": {
    "message": "貼上"
  },
  "pause_12af3bb4": {
    "message": "暫停"
  },
  "pentagon_17d82ea3": {
    "message": "五角形"
  },
  "people_b4ebb13c": {
    "message": "成員"
  },
  "percentage_34ab7c2c": {
    "message": "百分比"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "百分比必須是數字"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "百分比必須至少為 { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "表演藝術圖示"
  },
  "perpendicular_7c48ede4": {
    "message": "垂直"
  },
  "phi_4ac33b6d": {
    "message": "φ"
  },
  "phi_variant_c9bb3ac5": {
    "message": "φ（變量）"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "體育圖示"
  },
  "pi_dc4f0bd8": {
    "message": "π"
  },
  "pi_variant_10f5f520": {
    "message": "π（變量）"
  },
  "pick_a_color_557abfb0": {
    "message": "選擇一種顏色"
  },
  "pink_68ad45cb": {
    "message": "粉紅色"
  },
  "pixels_52ece7d1": {
    "message": "像素"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "像素必須至少為 { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "播放"
  },
  "play_media_comment_35257210": {
    "message": "播放媒體評論。"
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "播放{ name }於{ createdAt }創建的媒體評論。"
  },
  "player_layout_14e09a29": {
    "message": "播放器佈局"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "請允許 Canvas 存取您的麥克風和網路攝影機。"
  },
  "please_choose_a_file_c2449cc": {
    "message": "請選擇一個檔案"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "請輸入一個檔案名稱"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "請輸入受支援平台的有效影片 URL。"
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "請選取支援類型的檔案"
  },
  "plus_d43cd4ec": {
    "message": "+"
  },
  "plus_minus_f8be2e83": {
    "message": "+/-"
  },
  "posted_when_a578f5ab": {
    "message": "已公佈：{ when }"
  },
  "power_set_4f26f316": {
    "message": "冪集"
  },
  "precedes_196b9aef": {
    "message": "之前"
  },
  "precedes_equal_20701e84": {
    "message": "等於之前"
  },
  "preformatted_d0670862": {
    "message": "已預先格式化"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "預覽"
  },
  "preview_53003fd2": {
    "message": "預覽"
  },
  "preview_a3f8f854": {
    "message": "預覽"
  },
  "preview_in_overlay_ed772c46": {
    "message": "覆蓋預覽"
  },
  "preview_inline_9787330": {
    "message": "預覽內嵌"
  },
  "previous_bd2ac015": {
    "message": "上一個"
  },
  "previous_findtext_8dfbfd30": {
    "message": "上一個 { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "之前選擇的顏色"
  },
  "prime_917ea60e": {
    "message": "質數"
  },
  "prime_numbers_13464f61": {
    "message": "質數"
  },
  "product_39cf144f": {
    "message": "產品"
  },
  "proportional_f02800cc": {
    "message": "成比例"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "協議必須為 ftp、http、https、mailto、skype、tel 或忽略此項"
  },
  "psi_e3f5f0f7": {
    "message": "ψ"
  },
  "published_c944a23d": {
    "message": "已發佈"
  },
  "published_when_302d8e23": {
    "message": "已發佈：{ when }"
  },
  "pumpkin_904428d5": {
    "message": "南瓜色"
  },
  "purple_7678a9fc": {
    "message": "紫色"
  },
  "quaternions_877024e0": {
    "message": "四合數"
  },
  "quiz_e0dcce8f": {
    "message": "測驗"
  },
  "quizzes_7e598f57": {
    "message": "測驗"
  },
  "rational_numbers_80ddaa4a": {
    "message": "有理數"
  },
  "real_numbers_7c99df94": {
    "message": "實數"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "實數部份（複數的）"
  },
  "record_7c9448b": {
    "message": "錄製"
  },
  "record_upload_media_5fdce166": {
    "message": "錄製/上傳媒體"
  },
  "recording_98da6bda": {
    "message": "正在錄製"
  },
  "red_8258edf3": {
    "message": "紅色"
  },
  "relationships_6602af70": {
    "message": "關聯"
  },
  "religion_icon_246e0be1": {
    "message": "宗教圖示"
  },
  "remove_f47dc62a": {
    "message": "移除"
  },
  "remove_filename_3ea029f6": {
    "message": "移除 { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "移除標題樣式"
  },
  "remove_link_d1f2f4d0": {
    "message": "移除連結"
  },
  "replace_all_d3d68b3": {
    "message": "全部取代"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "以 { replaceText } 取代所有的 { findText }"
  },
  "replace_e61834a7": {
    "message": "替換"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "以 { replaceText } 取代 { findText }"
  },
  "replace_with_eeff01ad": {
    "message": "取代為"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "以 { alertReplaceText } 取代 { alertFindText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "以 { alertReplaceText } 取代所有的 { alertFindText }"
  },
  "reset_95a81614": {
    "message": "重設"
  },
  "resize_ec83d538": {
    "message": "調校大小"
  },
  "restore_auto_save_deccd84b": {
    "message": "還原自動儲存？"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "{ max } 的結果 { index }。"
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "反向 T 形符號（不產生）"
  },
  "rho_a0244a36": {
    "message": "ρ"
  },
  "rho_variant_415245cd": {
    "message": "ρ（變量）"
  },
  "rich_content_editor_2708ef21": {
    "message": "多種格式的內容編輯器"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "多種格式的文字區。按下用於多種格式的內容編輯器快速鍵的 { OSKey }+F8。"
  },
  "right_71ffdc4d": {
    "message": "右"
  },
  "right_align_39e7a32a": {
    "message": "靠右對齊"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "右角括號"
  },
  "right_arrow_35e0eddf": {
    "message": "右箭頭"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "右箭頭與鉤號"
  },
  "right_ceiling_839dc744": {
    "message": "右上限"
  },
  "right_curly_brace_5159d5cd": {
    "message": "右大括號"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "右向下魚叉箭頭"
  },
  "right_floor_5392d5cf": {
    "message": "右下限"
  },
  "right_to_left_9cfb092a": {
    "message": "右至左"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "右向上魚叉箭頭"
  },
  "rightward_arrow_32932107": {
    "message": "向右箭頭"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "向右指向三角形"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "逆時針旋轉影像 90 度"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "順時針旋轉影像 90 度"
  },
  "rotation_9699c538": {
    "message": "旋轉"
  },
  "row_fc0944a7": {
    "message": "行"
  },
  "row_group_979f5528": {
    "message": "行組"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "很遺憾，美觀 HTML 編輯器無法用鍵盤存取。在這裡存取原始 HTML 編輯器。"
  },
  "save_11a80ec3": {
    "message": "儲存"
  },
  "save_copy_ca63944e": {
    "message": "儲存複本"
  },
  "save_media_cb9e786e": {
    "message": "儲存媒體"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "儲存的圖示製作者圖示"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "沒有替代文字，屏幕閱讀器不能判斷圖像所顯示的是什麼，而檔案名稱一般都是無意義的數字與字母串，並不能說明內容或意義。"
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "沒有說明圖像內容與意義的替代文字，屏幕閱讀器不能判斷圖像所顯示的是什麼。替代文字應為精簡。"
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "沒有說明圖像內容與意義的替代文字，屏幕閱讀器不能判斷圖像所顯示的是什麼。"
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "沒有適當的結構，屏幕閱讀器不能解讀表格。表格標題能提供方向與內容範圍。"
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "沒有適當的結構，屏幕閱讀器不能解讀表格。表格字幕說明表格的內容與一般理解。"
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "沒有適當的結構，屏幕閱讀器不能解讀表格。表格標題能提供方向與內容概要。"
  },
  "script_l_42a7b254": {
    "message": "指令集 L"
  },
  "search_280d00bd": {
    "message": "搜尋"
  },
  "select_audio_source_21043cd5": {
    "message": "選擇音訊資源"
  },
  "select_crop_shape_d441feeb": {
    "message": "選擇裁剪形狀"
  },
  "select_language_7c93a900": {
    "message": "選擇語言"
  },
  "select_video_source_1b5c9dbe": {
    "message": "選擇視訊資源"
  },
  "selected_274ce24f": {
    "message": "已選擇"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "已選定 { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "選取"
  },
  "set_header_scope_8c548f40": {
    "message": "設定標題範圍"
  },
  "set_minus_b46e9b88": {
    "message": "設定 -"
  },
  "set_table_header_cfab13a0": {
    "message": "設定表格標題"
  },
  "sharp_music_ab956814": {
    "message": "#（音樂）"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+箭頭"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "按 Shift-O 開啟美觀 HTML 編輯器。"
  },
  "shortcut_911d6255": {
    "message": "快速鍵"
  },
  "show_image_options_1e2ecc6b": {
    "message": "顯示影像選項"
  },
  "show_link_options_545338fd": {
    "message": "顯示連結選項"
  },
  "show_rolling_transcript_c1481744": {
    "message": "顯示滾動成績單"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "顯示滾動成績單"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "有視力的使用者能迅速瀏覽網頁，尋找大型或粗體標題。屏幕閱讀器使用者依靠標題理解內容背景。標題應使用適當的結構。"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "有視力的使用者能迅速瀏覽網頁，尋找大型或粗體標題。屏幕閱讀器使用者依靠標題理解內容背景。標題應使用適當的結構，並保持精簡。"
  },
  "sigma_5c35e553": {
    "message": "σ"
  },
  "sigma_variant_8155625": {
    "message": "σ（變量）"
  },
  "single_color_image_4e5d4dbc": {
    "message": "單色圖像"
  },
  "single_color_image_color_95fa9a87": {
    "message": "單色 圖像顏色"
  },
  "size_b30e1077": {
    "message": "大小"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "字幕檔案大小大於最大 { max } kb 允許的檔案大小。"
  },
  "small_b070434a": {
    "message": "小"
  },
  "small_width_x_height_px_359acd38": {
    "message": "小尺寸（{ width } x { height }像素）"
  },
  "solid_circle_9f061dfc": {
    "message": "實心圓圈"
  },
  "something_went_wrong_89195131": {
    "message": "出現問題。"
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "存取網路攝影機出現問題。"
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "出現問題；我不知道應該展示什麼內容。"
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "出現問題。請檢查您的連線，重新載入頁面，然後再試一次。"
  },
  "something_went_wrong_d238c551": {
    "message": "似乎出問題了"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "分享您的畫面時發生錯誤。"
  },
  "sort_by_e75f9e3e": {
    "message": "排序依據"
  },
  "spades_suit_b37020c2": {
    "message": "黑桃（花色）"
  },
  "square_511eb3b3": {
    "message": "正方形"
  },
  "square_cap_9ec88646": {
    "message": "方帽"
  },
  "square_cup_b0665113": {
    "message": "方杯"
  },
  "square_root_e8bcbc60": {
    "message": "平方根"
  },
  "square_root_symbol_d0898a53": {
    "message": "平方根符號"
  },
  "square_subset_17be67cb": {
    "message": "平方子集合"
  },
  "square_subset_strict_7044e84f": {
    "message": "平方子集合（嚴格）"
  },
  "square_superset_3be8dae1": {
    "message": "平方母集合"
  },
  "square_superset_strict_fa4262e4": {
    "message": "平方母集合（嚴格）"
  },
  "square_unordered_list_b15ce93b": {
    "message": "方形無序清單"
  },
  "star_8d156e09": {
    "message": "星形"
  },
  "start_over_f7552aa9": {
    "message": "重新開始"
  },
  "start_recording_9a65141a": {
    "message": "開始錄製"
  },
  "steel_blue_14296f08": {
    "message": "鋼鐵藍"
  },
  "studio_media_options_ee504361": {
    "message": "Studio 媒體選項"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Studio 媒體選項收集箱"
  },
  "styles_2aa721ef": {
    "message": "樣式"
  },
  "submit_a3cc6859": {
    "message": "提交"
  },
  "submitting_b90fac62": {
    "message": "正在提交..."
  },
  "subscript_59744f96": {
    "message": "下標"
  },
  "subset_19c1a92f": {
    "message": "子集合"
  },
  "subset_strict_8d8948d6": {
    "message": "子集合（嚴格）"
  },
  "succeeds_9cc31be9": {
    "message": "之後"
  },
  "succeeds_equal_158e8c3a": {
    "message": "之後等於"
  },
  "sum_b0842d31": {
    "message": "總和"
  },
  "superscript_8cb349a2": {
    "message": "上標"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "上標和下標"
  },
  "superset_c4db8a7a": {
    "message": "母集合"
  },
  "superset_strict_c77dd6d2": {
    "message": "母集合（嚴格）"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "支援的檔案類型：SRT 或 WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "切換到美觀的 HTML 編輯器"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "切換到原始 HTML 編輯器"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "切換到 html 編輯器"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "切換到多種格式的文字編輯器"
  },
  "syllabus_f191f65b": {
    "message": "課程大綱"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "允許系統音訊"
  },
  "system_audio_disabled_c177bd13": {
    "message": "停用系統音訊"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/箭頭"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "以 { start } 開始的表格標題"
  },
  "table_starting_with_start_e7232848": {
    "message": "以 { start } 開始的表格"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "表格標題應指定範圍。"
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "表格應包括字幕說明表格內容。"
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "表格應包括最少一個標題。"
  },
  "tau_880974b7": {
    "message": "τ"
  },
  "teal_f729a294": {
    "message": "深青色"
  },
  "text_7f4593da": {
    "message": "文字"
  },
  "text_background_color_16e61c3f": {
    "message": "文字背景顏色"
  },
  "text_color_acf75eb6": {
    "message": "文字顏色"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "文字與背景之間對比不足，難以閱讀文字，對於視力較差的人尤其如是。"
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "大小為 18pt（或粗體 14pt）以上的文字的色彩比最少應達到 3:1。"
  },
  "text_optional_384f94f7": {
    "message": "文字（選用）"
  },
  "text_position_8df8c162": {
    "message": "文字位置"
  },
  "text_size_887c2f6": {
    "message": "文字大小"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "大小為 18pt（或粗體 14pt）以下的文字的色彩比最少應達到 4.5:1。"
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "文件預覽目前正在處理中。請稍後重試。"
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "頁面的第一個標題應該是 H2。"
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "多種格式的內容區域的高度已減少。"
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "多種格式的內容區域的高度已增加。"
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "該材料位於公用網域中。"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "該材料在創意共享項下獲得授權"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "可能有適用於此資料的例外情況 - 如：合理使用、引用權，或適用版權法下的其他情況"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "美觀 HTML 編輯器無法用鍵盤存取。按 ShiftO 開啟原始 HTML 編輯器。"
  },
  "therefore_d860e024": {
    "message": "因此"
  },
  "theta_ce2d2350": {
    "message": "θ"
  },
  "theta_variant_fff6da6f": {
    "message": "θ（變體）"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "粗向下箭頭"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "粗左箭頭"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "粗向左箭頭"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "粗右箭頭"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "粗向右箭頭"
  },
  "thick_upward_arrow_acd20328": {
    "message": "粗向上箭頭"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "在 Canvas 中無法顯示此文件。"
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "此方程式不能在基本視圖中呈現。"
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "此圖像目前不可用"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "此影片可能會顯示 YouTube 廣告。"
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "雖然您的影片在瀏覽器中有正確的標題，但我們無法在資料庫中將其更新。"
  },
  "thumbnail_e0de666f": {
    "message": "縮略圖"
  },
  "timebar_a4d18443": {
    "message": "時間欄"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "標題不能為空"
  },
  "title_ee03d132": {
    "message": "標題"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "待公佈：{ when }"
  },
  "to_do_when_2783d78f": {
    "message": "待辦事項：{ when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "切換 { summary } 群組"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "切換工具提示"
  },
  "tools_2fcf772e": {
    "message": "工具"
  },
  "top_66e0adb6": {
    "message": "頂部"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "成績單面板在寬度大於 720 像素時可用。"
  },
  "tray_839df38a": {
    "message": "收集箱"
  },
  "triangle_6072304e": {
    "message": "三角形"
  },
  "turnstile_yields_f9e76df1": {
    "message": "T 形符號（產生）"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "輸入 Control F9 以存取影像選項。{ text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "輸入 Control F9 以存取連結選項。{ text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "輸入 Control F9 以存取表格選項。{ text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "無法決定資源選擇網址"
  },
  "underline_applied_ae01ec97": {
    "message": "已套用底線"
  },
  "underline_removed_3693e17c": {
    "message": "已移除底線"
  },
  "union_e6b57a53": {
    "message": "聯集"
  },
  "unpublished_dfd8801": {
    "message": "未發佈"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "未儲存的變更都將遺失。"
  },
  "untitled_16aa4f2b": {
    "message": "無標題"
  },
  "untitled_efdc2d7d": {
    "message": "無標題"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "向上和向左對角箭頭"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "向上和向右對角箭頭"
  },
  "up_c553575d": {
    "message": "向上"
  },
  "updated_link_a827e441": {
    "message": "更新的連結"
  },
  "upload_document_253f0478": {
    "message": "上傳文件"
  },
  "upload_file_fd2361b8": {
    "message": "上傳檔案"
  },
  "upload_image_6120b609": {
    "message": "上載影像"
  },
  "upload_media_ce31135a": {
    "message": "上傳媒體"
  },
  "upload_record_media_e4207d72": {
    "message": "上傳/錄製媒體"
  },
  "uploading_19e8a4e7": {
    "message": "正在上傳"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "大寫字母有序清單"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "大寫 Δ"
  },
  "uppercase_gamma_86f492e9": {
    "message": "大寫 Γ"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "大寫 Λ"
  },
  "uppercase_omega_8aedfa2": {
    "message": "大寫 Ω"
  },
  "uppercase_phi_caa36724": {
    "message": "大寫 Φ"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "大寫 Π"
  },
  "uppercase_psi_6395acbe": {
    "message": "大寫 Ψ"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "大寫羅馬數字有序清單"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "大寫 Σ"
  },
  "uppercase_theta_49afc891": {
    "message": "大寫 Θ"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "大寫 Υ"
  },
  "uppercase_xi_341e8556": {
    "message": "大寫 Ξ"
  },
  "upsilon_33651634": {
    "message": "υ"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "向上和向下指向箭頭"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "向上和向下指向箭頭（粗）"
  },
  "upward_arrow_9992cb2d": {
    "message": "向上箭頭"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "向上指向三角形"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "使用權："
  },
  "usage_rights_required_5fe4dd68": {
    "message": "使用權限（需要）"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "使用箭頭鍵導航選項。"
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "使用箭頭鍵選擇形狀。"
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "使用箭頭鍵選擇大小。"
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "使用箭頭鍵選擇文字位置。"
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "使用箭頭鍵選擇文字大小。"
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "使用箭頭鍵選擇提綱大小。"
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "由螢幕讀取器使用以描述 { TYPE } 的內容"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "由螢幕讀取器使用以描述影像的內容"
  },
  "user_documents_c206e61f": {
    "message": "使用者文件"
  },
  "user_files_78e21703": {
    "message": "使用者檔案"
  },
  "user_images_b6490852": {
    "message": "使用者影像"
  },
  "user_media_14fbf656": {
    "message": "使用者媒體"
  },
  "vector_notation_cf6086ab": {
    "message": "向量（記數法）"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "垂列（設定建議符號）"
  },
  "vertical_dots_bfb21f14": {
    "message": "垂直點"
  },
  "video_options_24ef6e5d": {
    "message": "影片選項"
  },
  "video_options_tray_3b9809a5": {
    "message": "影片選項收集箱"
  },
  "video_player_b371005": {
    "message": "影片播放器"
  },
  "video_player_for_9e7d373b": {
    "message": "影片播放器，標題為 "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "{ title } 的影片播放器"
  },
  "video_url_889d3263": {
    "message": "影片網址"
  },
  "view_all_e13bf0a6": {
    "message": "全部檢視"
  },
  "view_ba339f93": {
    "message": "檢視"
  },
  "view_description_30446afc": {
    "message": "檢視描述"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "檢視鍵盤快速鍵"
  },
  "view_title_description_67940918": {
    "message": "檢視 { title } 描述"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "檢視文字和字元計數"
  },
  "viewer_restrictions_e14274c9": {
    "message": "檢視器限制"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "我們偵測不到與您的裝置連線的工作中麥克風。"
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "我們偵測不到與您的裝置連線的工作中攝影機。"
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "我們偵測不到與您的裝置連線的工作中攝影機或麥克風。"
  },
  "webcam_disabled_30c66986": {
    "message": "停用網路攝影機"
  },
  "webcam_fe91b20f": {
    "message": "網路攝影機"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "網頁應該僅有一個 H1，由頁面的標題自動使用。您的內容中的第一個標題應該是 H2。"
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "如果使用標記使項目看起來像清單，但並未標示其清單關係，使用者瀏覽資訊時或會有困難。"
  },
  "white_87fa64fd": {
    "message": "白色"
  },
  "why_523b3d8c": {
    "message": "為什麼"
  },
  "width_492fec76": {
    "message": "寬度"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "寬度和高度必須是數字"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki 首頁"
  },
  "word_count_c77fe3a6": {
    "message": "字數計算"
  },
  "words_b448b7d5": {
    "message": "文字"
  },
  "wreath_product_200b38ef": {
    "message": "花環產品"
  },
  "xi_149681d0": {
    "message": "ξ"
  },
  "yes_dde87d5": {
    "message": "是"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "您正在調色盤上。若要在調色盤上向上、向左、向下或向右導覽，請分別使用 ''W’、''A’、''S’ 和 ''D’ 按鈕"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "您正在顏色滑鈕上。若要使用滑鈕向左或向右導覽，請分別使用 ''A’ 和 ''D’ 按鈕"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "您正在 α 滑鈕上。若要使用滑鈕向左或向右導覽，請分別使用 ''A’ 和 ''D’ 按鈕"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "您在圖示製作者收集箱中有未儲存的變更。是否要繼續，但不儲存這些變更？"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "您可能需要調整其他標題以保持頁面階層。"
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "不可上傳空白檔案。"
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "您的影像已壓縮用於圖示製作者。將不壓縮小於 { size } KB 的影像。"
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "您的麥克風在瀏覽器設定中遭到封鎖。"
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "您的攝影機麥克風在瀏覽器設定中遭到封鎖。"
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "您的攝影機在瀏覽器設定中遭到封鎖。"
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "您的網路攝影機可能已在使用中。"
  },
  "youtube_embed_url_5c1018d4": {
    "message": "YouTube 嵌入網址"
  },
  "zeta_5ef24f0e": {
    "message": "θ"
  },
  "zoom_f3e54d69": {
    "message": "縮放"
  },
  "zoom_in_image_bb97d4f": {
    "message": "放大影像"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "縮小影像"
  }
};
formatMessage.addLocale({
  'zh-HK': locale
});